import { render, staticRenderFns } from "./pnlNotificationSetting.vue?vue&type=template&id=3e58638d&"
import script from "./pnlNotificationSetting.vue?vue&type=script&lang=ts&"
export * from "./pnlNotificationSetting.vue?vue&type=script&lang=ts&"
import style0 from "./pnlNotificationSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports